<template>
  <div class="skeleton" :class="type == 'list' ? 'skeleton_list' : 'skeleton_con'">
    <div class="skeleton-content" v-if="type == 'list'">
      <h3 class="skeleton-title" style="width: 38%;"></h3>
      <ul class="skeleton-paragraph">
        <li style="width: 40%;"></li>
        <li style="width: 67%;"></li>
        <li style="width: 43%;"></li>
        <li style="width: 50%;"></li>
        <li style="width: 23%;"></li>
      </ul>
      <h3 class="skeleton-title" style="width: 38%;"></h3>
      <ul class="skeleton-paragraph">
        <li style="width: 60%;"></li>
        <li style="width: 24%;"></li>
        <li style="width: 45%;"></li>
        <li style="width: 50%;"></li>
        <li style="width: 36%;"></li>
      </ul>
      <h3 class="skeleton-title" style="width: 38%;"></h3>
      <ul class="skeleton-paragraph">
        <li style="width: 20%;"></li>
        <li style="width: 67%;"></li>
        <li style="width: 54%;"></li>
        <li style="width: 80%;"></li>
        <li style="width: 33%;"></li>
      </ul>
    </div>
    <div class="skeleton-content" v-else>
      <h3 class="skeleton-title" style="width: 87%;"></h3>
      <h3 class="skeleton-title" style="width: 34%;margin-top: 12px;"></h3>
      <ul class="skeleton-paragraph" style="margin-top: 50px;">
        <li style="width: 40%;"></li>
        <li style="width: 67%;"></li>
        <li style="width: 43%;"></li>
        <li style="width: 50%;"></li>
        <li style="width: 23%;"></li>
        <li style="width: 42%;"></li>
        <li style="width: 57%;"></li>
        <li style="width: 83%;"></li>
        <li style="width: 60%;"></li>
        <li style="width: 27%;"></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Skeleton',
  props: ['type'],
}
</script>

<style scoped>
.skeleton {
  display: table;
  width: 100%;
}
.skeleton_list{
  margin-top: 155px;
}
.skeleton_con{
  margin-top: 40px;
}
.skeleton-content {
  display: table-cell;
  width: 100%;
  vertical-align: top;
}
.skeleton-title{
  width: 100%;
  height: 32px;
  background: #f2f2f2;
  margin: 0;
}
.skeleton-paragraph{
  margin-top: 55px;
}
.skeleton-paragraph +  .skeleton-title{
  margin-top: 150px;
}
.skeleton-paragraph > li{
  width: 100%;
  height: 16px;
  list-style: none;
  background: #f2f2f2;
}
.skeleton-title, .skeleton-paragraph > li{
  background: linear-gradient(90deg,#f0f0f0 25%,#e3e3e3 40%,#f0f0f0 63%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.5s ease infinite;
}
.skeleton-paragraph > li + li{
  margin-top: 28px;
}
.skeleton_list li{
  height: 20px;
}
@keyframes skeleton-loading {
  0%{
    background-position: 100% 50%;
  }
  100%{
    background-position: 0 50%;
  }
}

@media (max-width: 767px){
  .skeleton_list{
    margin: 0;
  }
  .skeleton_con{
    margin-top: 40px;
  }
  .skeleton-title{
    line-height: .58rem;
  }
  .skeleton-paragraph{
    margin-top: .38rem;
  }
  .skeleton-paragraph li {
    height: .42rem;
  }
  .skeleton-paragraph li + li{
    margin-top: .38rem;
  }
  .skeleton-paragraph + .skeleton-title{
    margin-top: 1.23rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/skeleton.vue